function splitIfPresent(val: string|undefined): string[] {
    if (typeof val === "string") {
        return val.split(",")
    } else {
        return []
    }
}

export interface EnumPreferenceValue {
    id: string
    offValue: boolean
    element: HTMLInputElement
}

export interface EnumPreference {
    type: "enum"
    defaultValue?: string
    values: Map<string, EnumPreferenceValue>
}

export interface NumericPreference {
    type: "number"
    defaultValue: number
    max: number
    min: number
    step: number
    id: string
    element: HTMLInputElement
}

export type Preference = EnumPreference|NumericPreference

export interface Preferences {
    items: Map<string, Preference>
}

export function getPreferences(): Preferences {
    const items = new Map<string, Preference>
    function setEnumPreferenceElement(name: string, value: string, id: string, offValue: boolean, element: HTMLInputElement): void {
        const pref = items.get(name) ?? { type: "enum", values: new Map<string, EnumPreferenceValue> }
        if (pref.type !== "enum") {
            console.warn(`invalid preference to have options: ${name} -> ${value}`)
            return
        }
        if (!items.has(name)) {
            items.set(name, pref)
        }
        if (pref.values.has(value)) {
            console.warn(`duplicate value: ${name} -> ${value}`)
        }
        pref.values.set(value, {id, offValue, element})
    }
    for (const element of document.querySelectorAll<HTMLInputElement>("input.persistedPreference[type=checkbox], input.persistedPreference[type=radio]")) {
        const name = element.name
        const id = element.id
        const possibleValues = [...splitIfPresent(element.value), ...splitIfPresent(element.dataset.altValues)]
        for (const value of possibleValues) {
            setEnumPreferenceElement(name, value, id, false, element)
        }
        const possibleOffValues = [...splitIfPresent(element.dataset.offValue), ...splitIfPresent(element.dataset.altOffValues)]
        for (const value of possibleOffValues) {
            setEnumPreferenceElement(name, value, id, true, element)
        }
        const pref = items.get(name)
        if (pref) {
            if (element.checked) {
                pref.defaultValue = possibleValues[0] ?? pref.defaultValue
            }
            if ("defaultValue" in element.dataset) {
                pref.defaultValue = possibleValues[0] ?? pref.defaultValue
            }
            if ("defaultOff" in element.dataset) {
                pref.defaultValue = possibleOffValues[0] ?? pref.defaultValue
            }
        }
    }
    for (const element of document.querySelectorAll<HTMLInputElement>("input.persistedPreference[type=range], input.persistedPreference[type=number]")) {
        const name = element.name
        const id = element.id
        const max = parseFloat(element.max)
        const min = parseFloat(element.min)
        const step = parseFloat(element.step)
        const defaultValue = element.valueAsNumber
        items.set(name, {
            type: "number",
            id,
            max,
            min,
            step,
            defaultValue,
            element
        })
    }
    return {
        items
    }
}

export const prefs: Preferences = {
    items: new Map<string, Preference>()
}

export function loadPagePreferences(): void {
    const loadedPrefs = getPreferences()
    Object.assign(prefs, loadedPrefs)
}